import { IconDeviceLaptop, IconMoon, IconSun } from "@tabler/icons-react";
import { useId } from "react";

import { useTheme } from "../../lib/theme";
import type { ThemePreference } from "../../lib/theme";

const OPTIONS: { value: ThemePreference; label: string; icon: JSX.Element }[] = [
  {
    value: "system",
    label: "Follow the machine",
    icon: <IconDeviceLaptop size={13} aria-hidden="true" />,
  },
  {
    value: "light",
    label: "Light",
    icon: <IconSun size={13} aria-hidden="true" />,
  },
  {
    value: "dark",
    label: "Dark",
    icon: <IconMoon size={13} aria-hidden="true" />,
  },
];

/**
 * Choose the palette, or hand the decision back to the machine.
 *
 * Three radios rather than a toggle: "follow the machine" is a real answer and
 * the one most people want, and a two-state switch cannot say it.
 *
 * Returns:
 *     The theme control.
 */
export function ThemeSwitch(): JSX.Element {
  const { preference, setPreference } = useTheme();
  const group = useId();

  return (
    <fieldset className="theme-switch">
      <legend className="theme-switch__label">Appearance</legend>
      <div className="theme-switch__options">
        {OPTIONS.map((option) => (
          <label
            key={option.value}
            className="theme-switch__option"
            data-selected={preference === option.value}
            title={option.label}
          >
            <input
              className="sr-only"
              type="radio"
              name={group}
              value={option.value}
              checked={preference === option.value}
              onChange={() => setPreference(option.value)}
            />
            {option.icon}
            <span className="sr-only">{option.label}</span>
          </label>
        ))}
      </div>
    </fieldset>
  );
}
